import React, { useEffect, useState } from 'react';
import { ResponsiveRadar } from '@nivo/radar';
import { notification, Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useLincfolioScoreMutation } from '../../slices/zerodhaApiSlice';
import { setScore } from '../../slices/dashboardSlice';

const LincfolioScore = (props) => {
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();
  const { date } = props;
  const { score } = useSelector((state) => state.dashboard);
  const { darkmode } = useSelector((state) => state.darkmode);
  const [lincfolioScore, { isLoading }] = useLincfolioScoreMutation();

  const getScores = async (startDate, endDate) => {
    try {
      const res = await lincfolioScore({ startDate, endDate }).unwrap();
      dispatch(setScore({ ...res }));
    } catch (err) {
      console.error(err);
      api.error({
        message: err?.data?.message || err.error || err?.data?.error,
      });
    }
  };

  useEffect(() => {
    if (date?.startDate && date?.endDate) {
      getScores(date.startDate, date.endDate);
    }

  }, [date]);

  const { Text } = Typography;

  // Define dynamic data based on the fetched score
  const data = [
    {
      metric: 'Win %',
      value: score != null ? Number(score.winpr).toFixed(2) : Number(0).toFixed(2),  // dynamic value
    },
    {
      metric: 'Profit Factor',
      value: score != null ? Number(score.lincprofitfactorPercent).toFixed(2) : Number(0).toFixed(2),  // dynamic value
    },
    {
      metric: 'Avg Win / Loss',
      value: score != null ? Number(score.lincavgwinlossPercent).toFixed(2) : Number(0).toFixed(2),  // dynamic value
    },
  ];
  const theme = {
    textColor: '#ffffff', // White text
    fontSize: 12,
    axis: {
      domain: {
        line: {
          stroke: '#777777', // Axis lines in light gray
        },
      },
      ticks: {
        line: {
          stroke: '#777777', // Ticks in light gray
        },
        text: {
          fill: '#ffffff', // Tick labels in white
        },
      },
    },
    grid: {
      line: {
        stroke: '#444444', // Grid lines in darker gray
      },
    },
    legends: {
      text: {
        fill: '#ffffff', // Legend text in white
      },
    },
    tooltip: {
      container: {
        background: '#333333', // Dark tooltip background
        color: '#ffffff', // Tooltip text color
      },
    },
  };

  return (
    <div style={{ height: 250, textAlign: 'center', marginBottom: '20px' }}>
      {contextHolder}
      <ResponsiveRadar
        data={data}
        keys={['value']}
        indexBy='metric'
        gridLabelOffset={14}
        valueFormat='>-.2f'
        margin={{ top: 20, right: 80, bottom: 20, left: 80 }}
        borderColor='inherit:darker(0.6)'
        gridShape='linear'
        dotSize={8}
        gridLevels={3}
        colors={{ scheme: 'category10' }}
        fillOpacity={darkmode ? 1 : 0.2}
        blendMode='multiply'
        theme={darkmode ? theme : null}
        legends={[
          {
            anchor: 'bottom-left',
            direction: 'column',
            translateX: -50,
            translateY: 0,
            itemWidth: 80,
            itemHeight: 20,
            itemTextColor: '#999',
            symbolSize: 12,
            symbolShape: 'circle',
          },
        ]}
      />
      <Text>Your Lincfolio Score is: <span style={{color: "#2980b9"}}>{Number(score != null ? score.lincwinScore + score.lincavgwinlossScore + score.lincprofitfactorScore : 0).toFixed(2)}</span></Text> 
    </div>
  );
};

export default LincfolioScore;
